import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import {
	Grid,
	Typography,
	Button,
	Table,
	TableBody,
	TableHead,
	TableRow,
	TableContainer,
	IconButton,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import Loading from '../ui/Loading.js'
import { StyledTableCell } from '../../commons/utils/TableStyles'
import * as Utils from '../../commons/utils/Utils'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import Timezone from '../../commons/timezone/Timezone.js'

const SafeFeedbackRankingDetalleModal = ({ conductor, onClose }) => {
	const [formularios, setFormularios] = useState([])
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		setLoading(true)
		Utils.getData('/safe-feedback-ranking/' + conductor.conductor_id + '/formularios-confirmados')
			.then((data) => {
				setFormularios(data)
			})
			.catch(() => {})
			.finally(() => setLoading(false))
	}, [conductor.conductor_id])

	return (
		<>
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item>
					<Typography variant="h6">
						<FormattedMessage
							id="SafeFeedbackRankingDetalleModal.titulo"
							defaultMessage="Formularios confirmados"
						/>
						{' — '}
						<b>{conductor.conductor}</b>
					</Typography>
				</Grid>
				<Grid item>
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
			</Grid>

			{loading && <Loading />}

			{!loading && (
				<TableContainer style={{ marginTop: 16, maxHeight: 400 }}>
					<Table stickyHeader size="small">
						<TableHead>
							<TableRow>
								<StyledTableCell align="left">
									<FormattedMessage id="SafeFeedbackRankingDetalleModal.col_fecha" defaultMessage="Fecha" />
								</StyledTableCell>
								<StyledTableCell align="left">
									<FormattedMessage id="SafeFeedbackRankingDetalleModal.col_tipo" defaultMessage="Tipo de formulario" />
								</StyledTableCell>
								<StyledTableCell align="left">
									<FormattedMessage id="SafeFeedbackRankingDetalleModal.col_id" defaultMessage="ID Evento" />
								</StyledTableCell>
								<StyledTableCell align="left">
									<FormattedMessage id="SafeFeedbackRankingDetalleModal.col_puntos" defaultMessage="Puntos" />
								</StyledTableCell>
								<StyledTableCell align="left">
									<FormattedMessage id="SafeFeedbackRankingDetalleModal.col_confirmado_por" defaultMessage="Confirmado por" />
								</StyledTableCell>
								<StyledTableCell align="left">
									<FormattedMessage id="SafeFeedbackRankingDetalleModal.col_vehiculo" defaultMessage="Vehículo" />
								</StyledTableCell>
								<StyledTableCell align="left">
									<FormattedMessage id="SafeFeedbackRankingDetalleModal.col_observaciones" defaultMessage="Observaciones" />
								</StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{formularios.length === 0 && (
								<TableRow>
									<StyledTableCell colSpan={7} align="center">
										<FormattedMessage
											id="SafeFeedbackRankingDetalleModal.sin_resultados"
											defaultMessage="No hay formularios confirmados para este conductor."
										/>
									</StyledTableCell>
								</TableRow>
							)}
							{formularios.map((formulario) => (
								<TableRow key={formulario.id}>
									<StyledTableCell align="left">
										{formulario.fecha_hora
											? LocaleFormat.formatDateTime(Timezone.getDateForClient(formulario.fecha_hora))
											: '—'}
									</StyledTableCell>
									<StyledTableCell align="left">{formulario.tipo_formulario}</StyledTableCell>
									<StyledTableCell align="left">#{formulario.id}</StyledTableCell>
									<StyledTableCell align="left">
										<b>{formulario.puntos_aplicados}</b>
									</StyledTableCell>
									<StyledTableCell align="left">{formulario.confirmado_por || '—'}</StyledTableCell>
									<StyledTableCell align="left">{formulario.dominio || '—'}</StyledTableCell>
									<StyledTableCell align="left">{formulario.comentario || '—'}</StyledTableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}

			<Grid container justifyContent="flex-end" style={{ marginTop: 16 }}>
				<Grid item>
					<Button onClick={onClose}>
						<FormattedMessage id="SafeFeedbackRankingDetalleModal.volver" defaultMessage="Volver" />
					</Button>
				</Grid>
			</Grid>
		</>
	)
}

export default SafeFeedbackRankingDetalleModal
